import { CellContext } from '@tanstack/react-table';
import { Avatar, Skeleton } from '@round/creatorbase-ui';
import { PlatformIcon, platformLabels } from 'Modules/Plans/helpers';
import ProfileLink from '../../../ProfileLink/ProfileLink';
import TruncatedText from '../../../TruncatedText/TruncatedText';
import { CreatorAccountRow, getMeta } from '../../helpers';
import styles from './CreatorCell.module.css';

type Props = CellContext<CreatorAccountRow, unknown>;

/**
 * The account as Creator Explore has it: its image and name, with its handle under them. An account
 * Explore has no name for goes by its handle.
 */
export const CreatorCell = ({ row: { original }, table }: Props) => {
    const { isExploreLoading, isImagesLoading } = getMeta(table);

    const name = original.exploreAccount?.full_name || original.handle;

    return (
        <div className={styles.container}>
            <Avatar className={styles.avatar} size="lg">
                {isExploreLoading || isImagesLoading ? (
                    <Skeleton className={styles.avatarSkeleton} />
                ) : (
                    <>
                        <Avatar.Image src={original.imageUrl ?? undefined} alt={name} />
                        <Avatar.Fallback>{name.charAt(0).toUpperCase()}</Avatar.Fallback>
                    </>
                )}
            </Avatar>

            <div className={styles.info}>
                {isExploreLoading ? (
                    <Skeleton className={styles.nameSkeleton} />
                ) : (
                    <div className={styles.name}>
                        <TruncatedText text={name} />
                    </div>
                )}
                <div className={styles.handle}>
                    <ProfileLink platform={original.platform} handle={original.handle} />
                    <PlatformIcon
                        platform={original.platform}
                        role="img"
                        aria-hidden={false}
                        aria-label={platformLabels[original.platform]}
                        className={styles.platformIcon}
                    />
                </div>
            </div>
        </div>
    );
};
